import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { LoggingService } from '@services/logging.service';
import { MonitoringService } from './monitoring.service';
import { WebAPIService } from './webapi.service';
import { concatMap, mergeMap, takeUntil } from 'rxjs/operators';
import { NonceService } from './nonce.service';
import { NavigationService } from '@services/navigation.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  private webAPIToken: any;
  private destroy$ = new Subject();
  private nonce: string;
  constructor(
    private http: HttpClient,
    private webAPIService: WebAPIService,
    private monitoringService: MonitoringService,
    private logger: LoggingService,
    private nonceService: NonceService,
    public navigationService: NavigationService,
  ) {
    this.logger.info(this.constructor.name, 'constructor', '');
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (window.location.host.endsWith('localhost:4200') && request.url.startsWith('/api')) {
      request = request.clone({
        url: `http://localhost:63758${request.url}`,
      });
    }

    // prevent infinite loop getting the bearer token to add when getting the bearer token
    if (
      request.url.endsWith('/api/auth/token') ||
      request.url.endsWith('/api/auth/ensureuser') ||
      request.url.endsWith('/api/auth/refreshtoken') ||
      request.url.includes('/api/config') ||
      request.url.includes('/api/nonce')
    ) {
      return next.handle(request);
    } else {
      return this.nonceService.getNonce().pipe(
        concatMap((nonce) => {
          request = request.clone({ headers: request.headers.append('X-Nonce', nonce) });
          if (this.navigationService.isLegacyStudy) {
            request = request.clone({ headers: request.headers.append('IsLegacyStudy', 'true') });//NonAI
          }
          return this.addWebAPITokenToRequest(request, next);
        }),
      );
    }
  }

  private addWebAPITokenToRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.logger.info(this.constructor.name, 'addWebAPITokenToRequest', 'Start');
    try {
      return this.webAPIService.getObservableWebAPITokenForCurrentUser().pipe(
        mergeMap((result: any) => {
          if (result) {
            this.webAPIToken = result;
            if (this.webAPIToken !== undefined && this.webAPIToken.token !== undefined) {
              // clone and modify the request, add the Authorization header
              request = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${this.webAPIToken.token}`,
                },
              });
            } else {
              this.logger.error(this.constructor.name, 'addWebAPITokenToRequest', `webAPIToken.token:[${this.webAPIToken.token}]`);
            }
          }

          return next.handle(request);
        }),
      );
    } finally {
      this.logger.info(this.constructor.name, 'addWebAPITokenToRequest', 'End');
    }
  }
}
